'use strict';

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './demand_report_index.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import SaGroupService from '../../../components/api/sa_group/sa_group.service';

export class DemandReportIndexController {
    /*@ngInject*/
    constructor(SaConfigService, SaGroupService) {
        this.saList = [];
        this.SaConfigService = SaConfigService;
        this.SaGroupService = SaGroupService;
    }

    $onInit() {
        this.SaConfigService.api.index((response) => {
            this.saList = response;
        });

        this.SaGroupService.api.index(response => {
            this.groupList = response
        });
    }
}

export default angular.module('leptonApp.demandReportIndex', [uiRouter, SaConfigService, SaGroupService])
    .config(routing)
    .component('demandReportIndex', {
        template: require('./demand_report_index.html'),
        controller: DemandReportIndexController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/index/demand_report_index.component.js